<template>
  <div class="indexContain" id="HPIndex">
    <div class="indexHeader">
      <IndexHeader ref="header"></IndexHeader>
    </div>
    <div class="indexInfo">
      <div class="projectCon">
        <el-select
          v-model="equipCode"
          @change="equipCodeChange"
          placeholder="请选设备"
        >
          <el-option
            v-for="item in equipList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>
      </div>
      <div class="infoContent">
        <div class="infoName"></div>
        <div class="infoItem">
          <div class="itemLeft">设备名称</div>
          <div class="itemRight">{{ info.name }}</div>
        </div>
        <div class="infoItem">
          <div class="itemLeft">设备编号</div>
          <div class="itemRight">{{ info.code }}</div>
        </div>
        <div class="infoItem">
          <div class="itemLeft">产品型号</div>
          <div class="itemRight">{{ info.model }}</div>
        </div>
        <div class="infoItem">
          <div class="itemLeft">品牌</div>
          <div class="itemRight">{{ info.brand }}</div>
        </div>
        <div class="infoItem">
          <div class="itemLeft">整机质量 (kg)</div>
          <div class="itemRight">{{ info.tonnage * 1000 }}</div>
        </div>
        <div class="infoItem">
          <div class="itemLeft">车身外壳长度</div>
          <div class="itemRight">{{ info.equipLength }}</div>
        </div>
        <div class="infoItem">
          <div class="itemLeft">车身外壳宽度</div>
          <div class="itemRight">{{ info.equipWidth }}</div>
        </div>
        <div class="infoItem">
          <div class="itemLeft">联系负责人</div>
          <div class="itemRight">{{ info.leader }}</div>
        </div>
        <div class="infoItem infoItem1">
          <div class="itemLeft">联系电话</div>
          <div class="itemRight">{{ info.phone }}</div>
        </div>
        <div class="infoItem">
          <div class="itemLeft">备注信息</div>
          <div class="itemRight">{{ info.remarks }}</div>
        </div>
      </div>
      <div class="imgContent">
        <img src="../images/pav.png" alt="" />
      </div>
      <div class="countContent">
        <div class="indexIcon"></div>
        <div class="indexTitle">
          行驶系统综合评分
          <div class="effect"></div>
        </div>
        <span class="countNumShow">{{scoreCode}}</span>
        <el-tooltip class="countNumShowTip" effect="dark" content="" placement="bottom-start">
          <div slot="content" style="font-size:14px">系统评分说明：<br/>◆ 80~100: 系统良好<br/>◆ 70~79: 系统正常<br/>◆ 60~69: 系统异常<br/>◆ 0~59: 系统故障</div>
          <el-button></el-button>
        </el-tooltip>
        <span class="countTextShow">排名/总数：3/12</span>
        <el-date-picker
          class="datePickerShow"
          v-model="monthValue"
          type="month"
          @change="monthChange"
          value-format="yyyy-MM"
          placeholder="选择月"
        >
        </el-date-picker>
        <div class="sountChart" id="sountChart"></div>
      </div>
      <div class="warnContent">
        <div class="indexIcon"></div>
        <div class="indexTitle">
          故障预警
          <div class="effect"></div>
        </div>
        <div class="itemContent">
          <div class="warnItem" v-for="(item, index) in warnList" :key="index">
            <img src="../images/icon/warn.png" alt="" />
            <span class="warningContentShow">{{ item.warningContent }}</span>
            <span class="warningTimeShow">{{ item.warningTime }}</span>
          </div>
        </div>
      </div>
      <div class="countItemContent">
        <img class="bottomImg" src="../images/all/indexType_4.png" alt="" />
        <div class="leftTravel">
          <div class="indexIcon"></div>
          <div class="indexTitle">
            左侧行驶系统
            <div class="effect"></div>
            
          </div>
          <div class="typeCheckCon">
            <el-select
              v-model="typeValue"
              @change="equipTypeChange"
              placeholder="请选类型"
            >
              <el-option
                v-for="item in typeList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </div>
          <div class="lookBox" @click="openInfoShowByType_1()">查看</div>
          <div class="scoreItem">
            <div class="itemShow">
              <span class="scoreNumShow">{{
                leftInfo.systemScore ? rightInfo.systemScore.toFixed(0) : "--"
              }}</span>
              <span class="scoreTextShow">系统评分</span>
            </div>
            <div class="itemShow_1">
              <span class="scoreNumShow">{{
                leftInfo.performanceScore ? leftInfo.performanceScore.toFixed(1) : "--"
              }}<span style="font-size:20px">%</span></span>
              <span class="scoreTextShow">系统效率</span>
            </div>
          </div>
          <div class="scoreItem_1">
            <div
              class="itemShow"
            >
              <span class="scoreNumShow">{{
                leftInfo.pumpLifeTime ? leftInfo.pumpLifeTime.toFixed(0) : "--"
              }}<span style="font-size:20px">%</span></span>
              <span class="scoreTextShow">行驶泵寿命</span>
            </div>
            <div class="itemShow_1">
              <span class="scoreNumShow">{{
                leftInfo.motorLifeTime ? leftInfo.motorLifeTime.toFixed(0) : "--"
              }}<span style="font-size:20px">%</span></span>
              <span class="scoreTextShow">行驶马达寿命</span>
            </div>
          </div>
        </div>
        <div class="rightTravel">
          <div class="indexIcon"></div>
          <div class="indexTitle">
            右侧行驶系统
            <div class="effect"></div>
          </div>
          <div class="typeCheckCon">
            <el-select
              v-model="typeValue_1"
              @change="equipTypeChange_1"
              placeholder="请选类型"
            >
              <el-option
                v-for="item in typeList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </div>
          <div class="lookBox" @click="openInfoShowByType_2()">查看</div>
          <div class="scoreItem">
            <div class="itemShow">
              <span class="scoreNumShow">{{
                rightInfo.systemScore ? (rightInfo.systemScore*1).toFixed(0) : "--"
              }}</span>
              <span class="scoreTextShow">系统评分</span>
            </div>
            <div class="itemShow_1">
              <span class="scoreNumShow">{{
                rightInfo.performanceScore ? rightInfo.performanceScore.toFixed(1) : "--"
              }}<span style="font-size:20px">%</span></span>
              <span class="scoreTextShow">系统效率</span>
            </div>
          </div>
          <div class="scoreItem_1">
            <div class="itemShow">
              <span class="scoreNumShow">{{
                rightInfo.pumpLifeTime ? rightInfo.pumpLifeTime.toFixed(0) : "--"
              }}<span style="font-size:20px">%</span></span>
              <span class="scoreTextShow">行驶泵寿命</span>
            </div>
            <div class="itemShow_1">
              <span class="scoreNumShow">{{
                rightInfo.motorLifeTime ? rightInfo.motorLifeTime.toFixed(0) : "--"
              }}<span style="font-size:20px">%</span></span>
              <span class="scoreTextShow">行驶马达寿命</span>
            </div>
          </div>
        </div>
      </div>
      <div class="adviseContent">
        <div class="indexIcon"></div>
        <div class="indexTitle">
          维保建议
          <div class="effect"></div>
        </div>
        <div class="itemContent">
          <div
            class="warnItem"
            v-for="(item, index) in repairList"
            :key="index"
          >
            <img src="../images/icon/repair.png" alt="" />
            <span class="warningContentShow">{{ item.adviseContent }}</span>
            <span class="warningTimeShow">{{ item.adviseTime }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="boxContain" v-show="openBoxShow">
      <div class="openBox">
        <div class="openTitle">
          <span class="titleText">{{ titleText }}</span>
          <div class="search-form-group">
            <label class="group-label" style="margin-right: 20px">日期</label>
            <el-date-picker
              size="medium"
              v-model="duration"
              @change="dateChange"
              type="daterange"
              range-separator="—"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </div>
        <img
          @click="closeBox"
          class="closeIcon"
          src="../images/icon/close.png"
          alt=""
        />

        <div class="openChart" id="openChart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import IndexHeader from "../components/common/indexHeader";
import {
  getPageFaultWarning,
  getPageMaintainAdvise,
  getDayComScore,
  getDrivingSystemScore,
  getStatisticOfWorkStatus,
  getSysEquipList,
  getRecentlyScore
} from "../utils/api";
import { dateFormat } from "../utils/commons.js";
export default {
  name: "app",
  data() {
    return {
      info: {
        modeType: "SAP90C8",
      },
      scoreCode:0 ,
      equipCode: "20LT77130156",
      warnList: [],
      repairList: [],
      sountChart: "",
      monthValue: "",
      openBoxShow: false,
      leftInfo: {},
      rightInfo: {},
      titleText: "",
      openChart: "",
      search: {
        direction: 0,
        endDate: "2022-05-20",
        equipCode: "20LT77130156",
        mode: 0,
        startDate: "2022-04-20",
        type: 1,
      },
      equipList: [],
      duration: ["2022-04-20", "2022-05-20"],
      duration_1: [],
      typeValue: '1',
      typeValue_1: '1',
      typeList: [
        {name:'行驶泵_转速压力',code:'0'},
        {name:'行驶泵_电流',code:'1'},
        {name:'行驶泵_功率',code:'2'},
        {name:'行驶泵_扭矩',code:'3'},
        {name:'行驶马达_转速压力',code:'4'},
        {name:'行驶马达_电流',code:'5'},
        {name:'行驶马达_功率',code:'6'},
        {name:'行驶马达_扭矩',code:'7'},
      ],
    };
  },
  mounted() {
    this.$refs.header.currentPageName = "设备评估";
    this.$refs.header.deviceVisible = true;
    this.$refs.header.monitorVisible = true;
    this.$refs.header.projectVisible = true;
    this.$refs.header.pavVisible = false;
    let getDate =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() < 10
        ? "0" + new Date().getMonth()
        : new Date().getMonth());
    this.monthValue = getDate;
    var date = new Date(new Date().getTime() - 24 * 60 * 60 * 1000 * 90);
    var month = date.getMonth() + 1;
    var day = date.getDate();
    let start =
      date.getFullYear() +
      "-" +
      (month < 10 ? "0" + month : month) +
      "-" +
      (day < 10 ? "0" + day : day);
    this.duration = [start, dateFormat(new Date(), "YYYY-MM-DD")];
    this.duration_1 = JSON.parse(JSON.stringify(this.duration));
    this.search.startDate = this.duration[0];
    this.search.endDate = this.duration[1];
    getSysEquipList({ corpCode: localStorage.getItem("corpCode") }).then(
      (res) => {
        this.equipList = res.data.content;
        this.equipCode = res.data.content[0].code;
        this.info = res.data.content[0];
        this.getInit(this.equipCode);
        this.getDayComScoreFun(this.equipCode, getDate);
        this.getRecentlyScoreFun(this.equipCode)
      }
    );
    
  },
  methods: {
    equipCodeChange(e) {
      console.log(e);
      this.equipCode = e;
      this.search.equipCode = e
      this.getInit(this.equipCode);
      this.getDayComScoreFun(this.equipCode, this.monthValue);

      let list = this.equipList
      for(let i=0;i<list.length;i++){
        if(e == list[i].code){
          this.info = list[i]
        }
      }
      this.getRecentlyScoreFun(e)
    },
    getRecentlyScoreFun(e){
      getRecentlyScore({equipCode:e}).then((res)=>{
        this.scoreCode = res.data.content
      })
    },
    equipTypeChange(e){
      this.typeValue = e
    },
    equipTypeChange_1(e){
      this.typeValue_1 = e
    },
    dateChange(e) {
      console.log(e);
      if (e == null) {
        this.search.startDate = "";
        this.search.endDate = "";
      } else {
        this.search.startDate = dateFormat(e[0], "YYYY-MM-DD");
        this.search.endDate = dateFormat(e[1], "YYYY-MM-DD");
      }
      this.duration = [this.search.startDate, this.search.endDate];
      this.getHeartChart();
    },
    getInit(e) {
      getPageFaultWarning({
        equipCode: e,
        pageNo: 1,
        pageSize: 10,
      }).then((res) => {
        this.warnList = res.data.content.list;
      });
      getPageMaintainAdvise({
        equipCode: e,
        pageNo: 1,
        pageSize: 10,
      }).then((res) => {
        this.repairList = res.data.content.list;
      });
      getDrivingSystemScore({
        equipCode: e,
        direction: 0,
      }).then((res) => {
        console.log(res);
        this.leftInfo = res.data.content ? res.data.content : {};
      });
      getDrivingSystemScore({
        equipCode: e,
        direction: 1,
      }).then((res) => {
        console.log(res);
        this.rightInfo = res.data.content ? res.data.content : {};
      });
    },
    getDayComScoreFun(e, d) {
      getDayComScore({
        equipCode: e,
        month: d,
      }).then((res) => {
        const echarts = require("echarts");
        let getData = res.data.content;
        this.sountChart = echarts.init(document.getElementById("sountChart"));
        const xAxisList = getData.map((item) => item.day.slice(8,10));
        const series = [
          {
            name: "",
            type: "bar",
            barWidth: 10,
            data: getData.map((item) => {
              return item.score.toFixed(2);
            }),
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#265DFD",
                  },
                  {
                    offset: 1,
                    color: "#0492FF",
                  },
                ]),
              },
            },
          },
        ];
        let option = {
          legend: {
            data: [""],
            textStyle: {
              color: "#fff",
              fontSize: 12,
            },
            top: 14,
            right: 10,
            itemHeight: 10,
            itemWidth: 10,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
          },
          grid: {
            left: 50,
            right: 40,
            top: 50,
            bottom: 40,
          },
          xAxis: [
            {
              type: "category",
              data: xAxisList,
              splitLine: {
                show: false,
              },
              axisLabel: {
                color: "#ffffff",
                fontSize: 10,
              },
              axisLine: {
                lineStyle: {
                  color: "#194793",
                },
              },
              axisTick: {
                show: false,
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              name: "",
              nameTextStyle: {
                color: "#ffffff",
                fontSize: 10,
              },
              // interval: '',
              splitLine: {
                show: true,
                lineStyle: {
                  color: ["#194793"],
                },
              },
              axisLabel: {
                color: "#ffffff",
                fontSize: 10,
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#878787",
                },
              },
              axisTick: {
                show: false,
              },
            },
          ],
          dataZoom: [
            {
              type: "slider",
              show: true,
              realtime: true,
              start: this.computedPosition(xAxisList),
              end: 100,
              handleSize: "10%",
              height: 10,
              handleStyle: {
                borderWidth: 2,
              },
              bottom: "0",
              borderColor: "#0492FF",
              fillerColor: "#265DFD",
            },
            {
              type: "inside",
              xAxisIndex: [0],
            },
            {
              type: "slider",
              yAxisIndex: [0],
              show: false,
              zoomLock: true,
            },
          ],
          series: series,
        };
        this.sountChart.setOption(option);
      });
    },
    computedPosition(e){
      if(e.length>=10){
          return 100 - Math.floor(10*100/e.length)
      }else{
          return 0;//小于十条数据显示全部
      }
    },
    getHeartChart() {
      const echarts = require("echarts");
      echarts.init(document.getElementById('openChart')).dispose();
      this.openChart = echarts.init(document.getElementById("openChart"));
      // prettier-ignore

      getStatisticOfWorkStatus(this.search).then(res=>{
        console.log(res)
        let xData = res.data.content.xlist
        let yData = res.data.content.ylist
        let yValue = res.data.content.valueList
        // for(let i=0;i<xData.length;i++){
        //   xData[i] = (xData[i]+1)*100 + 'rpm'
        // }
        // for(let i=0;i<yData.length;i++){
        //   yData[i] = (yData[i]+1)*10 + 'bar'
        // }
        console.log('xData',xData)
        console.log('yData',yData)
        console.log('this.search.type',this.search.type)
        const hours = xData
        const days = yData
        const data = res.data.content.data?(res.data.content.data.map(function (item) {
            return [item[0], item[1], item[2] || '-'];
        })):'';
        if(this.search.type == '0' || this.search.type == '4'){
          let option = {
            tooltip: {
              position: "top",
              // trigger: 'axis',
              axisPointer: {
                type: 'cross',
                label: {
                  backgroundColor: '#6a7985'
                }
              }
              // trigger: 'axis',
              // formatter: '{a0}' + '/' + '{b0}' + '/' + '{c0}'
            },
            grid: {
              height: "90%",
              width: "90%",
              top: "5%",
              left: "5%",
              backgroundColor: '#ff0000'
            },
            xAxis: {
              type: "category",
              name: "单位(RPM)",
              nameTextStyle: {
                  color: "#ffffff",
                  fontSize: 10,
                },
              data: hours,
              splitArea: {
                show: false,
              },
              axisLabel: {
                show: true,
                  textStyle: {
                    color: '#c3dbff',  //更改坐标轴文字颜色
                    fontSize : 14      //更改坐标轴文字大小
                  }
              },
              splitLine:{
                show: true,
                lineStyle:{
                  color: 'rgba(33,122,166,0.2)'
                }
              },
              axisLine:{
                lineStyle:{
                  color: 'rgba(33,122,166,0.2)'
                }
              }
            },
            yAxis: {
              type: "category",
              name: "单位(bar)",
              nameTextStyle: {
                  color: "#ffffff",
                  fontSize: 10,
                },
              data: days,
              splitArea: {
                show: false,
              },
              axisLabel: {
                show: true,
                  textStyle: {
                    color: '#c3dbff',  //更改坐标轴文字颜色
                    fontSize : 14      //更改坐标轴文字大小
                  }
              },
              splitLine:{
                show: true,
                lineStyle:{
                  color: 'rgba(33,122,166,0.2)'
                }
              },
              axisLine:{
                lineStyle:{
                  color: 'rgba(33,122,166,0.2)'
                }
              }
            },
            visualMap: {
              min: 0,
              max: 3600,
              calculable: true,
              orient: "horizontal",
              left: "center",
              top: "0%",
              splitNumber: 5,
              textStyle:{
                fontSize: 10,//字体大小
                color: '#ffffff'//字体颜色
              },
              inRange: {
              color: ['#999999', '#F5DEB3', '#F4A460', '#e16f56', '#EB190A', ]
              },
            },
            series: [
              {
                name: "持续秒数",
                type: "heatmap",
                data: data,
                label: {
                  show: true,
                },
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
              },
            ],
          };
          this.openChart.setOption(option);
        }else{
          const series = [
            {
              name: "",
              type: "bar",
              barWidth: 10,
              data: yValue,
              itemStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: "#265DFD",
                    },
                    {
                      offset: 1,
                      color: "#0492FF",
                    },
                  ]),
                },
              },
            },
          ];
          let option = {
            legend: {
              data: [""],
              textStyle: {
                color: "#fff",
                fontSize: 12,
              },
              top: 14,
              right: 10,
              itemHeight: 10,
              itemWidth: 10,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                crossStyle: {
                  color: "#999",
                },
              },
            },
            grid: {
              left: 50,
              right: 70,
              top: 50,
              bottom: 40,
            },
            xAxis: [
              {
                type: "category",
                name: this.search.type == '1'||this.search.type == '5'?'单位(mA)':this.search.type == '2'||this.search.type == '6'?'单位(kW)':this.search.type == '3'||this.search.type == '7'?'单位(Nm)':'',
                nameTextStyle: {
                  color: "#ffffff",
                  fontSize: 10,
                },
                data: xData,
                splitLine: {
                  show: false,
                },
                axisLabel: {
                  color: "#ffffff",
                  fontSize: 10,
                },
                axisLine: {
                  lineStyle: {
                    color: "#194793",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "单位(s)",
                nameTextStyle: {
                  color: "#ffffff",
                  fontSize: 10,
                },
                // interval: '',
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: ["#194793"],
                  },
                },
                axisLabel: {
                  color: "#ffffff",
                  fontSize: 10,
                },
                axisLine: {
                  show: false,
                  lineStyle: {
                    color: "#878787",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            dataZoom: [
              {
                type: "slider",
                show: true,
                realtime: true,
                start: 0,
                end: 100,
                handleSize: "10%",
                height: 10,
                handleStyle: {
                  borderWidth: 2,
                },
                bottom: "0",
                borderColor: "#0492FF",
                fillerColor: "#265DFD",
              },
              {
                type: "inside",
                xAxisIndex: [0],
              },
              {
                type: "slider",
                yAxisIndex: [0],
                show: false,
                zoomLock: true,
              },
            ],
            series: series,
          };
          this.openChart.setOption(option);
        }
        
      })
    },
    monthChange(e) {
      console.log(e);
      this.monthValue = e;
      if (e) {
        this.getDayComScoreFun(this.equipCode, e);
      }
    },
    openInfoShow(e) {
      this.openBoxShow = true;
      switch (e) {
        case 1:
          this.titleText = "左侧行驶泵工况占比";
          this.search.direction = 0;
          this.search.type = 0;
          break;
        case 2:
          this.titleText = "左侧行驶马达工况占比";
          this.search.direction = 0;
          this.search.type = 1;
          break;
        case 3:
          this.titleText = "右侧行驶泵工况占比";
          this.search.direction = 1;
          this.search.type = 0;
          break;
        case 4:
          this.titleText = "右侧行驶马达工况占比";
          this.search.direction = 1;
          this.search.type = 1;
          break;
      }
      this.duration = JSON.parse(JSON.stringify(this.duration_1));
      this.search.startDate = this.duration[0];
      this.search.endDate = this.duration[1];
      this.getHeartChart();
    },
    openInfoShowByType_1(){
      this.openBoxShow = true;
      this.search.direction = 0;
      this.search.type = this.typeValue
      switch(this.typeValue){
        case '0':
          this.titleText = "左侧行驶泵转速压力";
          break;
        case '1':
          this.titleText = "左侧行驶泵电流";
          break;
        case '2':
          this.titleText = "左侧行驶泵功率";
          break;
        case '3':
          this.titleText = "左侧行驶泵扭矩";
          break;
        case '4':
          this.titleText = "左侧行驶马达转速压力";
          break;
        case '5':
          this.titleText = "左侧行驶马达电流";
          break;
        case '6':
          this.titleText = "左侧行驶马达功率";
          break;
        case '7':
          this.titleText = "左侧行驶马达扭矩";
          break;
      }
      this.duration = JSON.parse(JSON.stringify(this.duration_1));
      this.search.startDate = this.duration[0];
      this.search.endDate = this.duration[1];
      this.getHeartChart();
    },
    openInfoShowByType_2(){
      this.openBoxShow = true;
      this.search.direction = 1;
      this.search.type = this.typeValue_1
      switch(this.typeValue_1){
        case '0':
          this.titleText = "右侧行驶泵转速压力";
          break;
        case '1':
          this.titleText = "右侧行驶泵电流";
          break;
        case '2':
          this.titleText = "右侧行驶泵功率";
          break;
        case '3':
          this.titleText = "右侧行驶泵扭矩";
          break;
        case '4':
          this.titleText = "右侧行驶马达转速压力";
          break;
        case '5':
          this.titleText = "右侧行驶马达电流";
          break;
        case '6':
          this.titleText = "右侧行驶马达功率";
          break;
        case '7':
          this.titleText = "右侧行驶马达扭矩";
          break;
      }
      this.duration = JSON.parse(JSON.stringify(this.duration_1));
      this.search.startDate = this.duration[0];
      this.search.endDate = this.duration[1];
      this.getHeartChart();
    },
    closeBox() {
      this.openBoxShow = false;
    },
  },
  components: {
    IndexHeader,
  },
};
</script>
<style lang="scss">
.is-dark{
  background-color: rgba(0, 0, 0, 0.8) !important;
}
@font-face {
  font-family: "dinbold";
  src: url("../assets/DIN-Bold.otf");
  font-stretch: "normal";
}
.BMapLabel {
  border: none !important;
  background: transparent !important;
}

#HPIndex .warning-row {
  background: rgba(245, 108, 108, 0.1);
  color: rgb(245, 108, 108);
}
.countContent {
  .el-date-editor {
    background-color: transparent;
    //         border-radius: 4px;
    // border: 1px solid #217AA6;
    .el-input__inner {
      background-color: transparent;
      border-radius: 4px;
      border: 1px solid #217aa6;
      color: #ffffff;
    }
  }
}
.projectCon {
  .el-input__inner {
    background-color: transparent;
    border-radius: 4px;
    border: 1px solid #217aa6;
    color: #ffffff;
  }
}
.typeCheckCon{
  .el-input__inner {
    background-color: transparent;
    border-radius: 4px;
    border: 1px solid #217aa6;
    color: #ffffff;
  }
}
.openTitle {
  color: #ffffff;
  .el-input__inner {
    background-color: transparent;
    border-radius: 4px;
    border: 1px solid #217aa6;
    color: #ffffff;
  }
  .el-range-input {
    background-color: transparent;
    color: #ffffff;
  }
  .el-range-separator {
    color: #ffffff;
  }
}
</style>
<style scoped lang="scss">
.boxContain {
  width: 100%;
  height: 100%;
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  z-index: 100;
}
.openBox {
  width: 1460px;
  height: 920px;
  background: rgba(13, 55, 128, 0.9);
  border-radius: 8px;
  border: 1px solid #217aa6;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
  .closeIcon {
    width: 24px;
    height: 24px;
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .openTitle {
    width: 80%;
    height: 32px;
    position: absolute;
    top: 20px;
    left: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .titleText {
      font-size: 18px;
      color: #ffffff;
      margin-right: 50px;
    }
  }
  .openChart {
    width: 1380px;
    height: 828px;
    border: 1px solid #217aa6;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 20px;
  }
}
.indexContain {
  background-image: url("../images/all/indexBG.png");
  background-size: 100% 100%;
  padding-bottom: 17px;
}
.indexHeader {
  width: 100%;
  height: 90px;
}
.indexInfo {
  width: 100%;
  margin-top: 5px;
  position: relative;
  height: 967px;
  .projectCon {
    position: absolute;
    width: 200px;
    z-index: 50;
    top: -45px;
    left: 20px;
  }
  .infoContent {
    position: absolute;
    top: 0;
    right: 20px;
    width: 454px;
    height: 480px;
    // background: linear-gradient(
    //   180deg,
    //   rgba(25, 53, 128, 0.9) 0%,
    //   rgba(13, 55, 128, 0) 100%
    // );

    background-image: url("../images/all/indexType_1.png");
    background-size: 100% 100%;
    .infoItem {
      width: 100%;
      height: 48px;
      border-bottom: 1px solid rgba(33, 122, 166, 0.2);
      .itemLeft {
        width: 152px;
        height: 100%;
        float: left;
        font-size: 14px;
        color: #81b6ff;
        line-height: 48px;
        text-align: right;
        padding-right: 20px;
      }
      .itemRight {
        width: 300px;
        height: 100%;
        float: left;
        font-size: 14px;
        color: #ffffff;
        line-height: 48px;
        text-align: left;
        padding-left: 19px;
      }
    }
    .infoItem1 {
      border-bottom: none;
    }
    .infoName {
      width: 152px;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: linear-gradient(
        180deg,
        rgba(25, 122, 255, 0.2) 0%,
        rgba(25, 122, 255, 0) 100%
      );
    }
  }
  .imgContent {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 928px;
    height: 480px;
    background: linear-gradient(
      180deg,
      rgba(25, 53, 128, 0.9) 0%,
      rgba(13, 55, 128, 0) 100%
    );
    border-radius: 8px;
    // border: 1px solid #59C8FF;
    // border-image: linear-gradient(180deg, rgba(33, 122, 166, 1), rgba(33, 122, 166, 0)) 1 1;

    img {
      width: 560px;
      height: 440px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .countContent {
    position: absolute;
    top: 0;
    left: 20px;
    width: 454px;
    height: 480px;
    background-image: url("../images/all/indexType_1.png");
    background-size: 100% 100%;
    .datePickerShow {
      position: absolute;
      right: 20px;
      top: 176px;
    }
    .countNumShow {
      display: inline-block;
      height: 83px;
      line-height: 83px;
      font-size: 68px;
      color: #ffad34;
      font-weight: bold;
      position: absolute;
      top: 40px;
      left: 50%;
      transform: translateX(-50%);
      font-family: "dinbold";
    }
    .countNumShowTip{
      display: inline-block;
      height: 83px !important;
      line-height: 83px;
      width: 200px;
      font-size: 68px;
      position: absolute;
      top: 40px;
      left: 50%;
      transform: translateX(-50%);
      font-family: "dinbold";
      opacity: 0;
    }
    .countTextShow {
      display: inline-block;
      height: 21px;
      line-height: 21px;
      font-size: 16px;
      color: #fff;
      // font-weight: bold;
      position: absolute;
      top: 126px;
      left: 50%;
      transform: translateX(-50%);
      font-family: MicrosoftYaHei;
    }
    .sountChart {
      width: 100%;
      height: 280px;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }

  .warnContent {
    position: absolute;
    bottom: 0;
    left: 20px;
    width: 454px;
    height: 480px;
    background-image: url("../images/all/indexType_1.png");
    background-size: 100% 100%;
    padding-top: 58px;
  }
  .itemContent {
    width: 100%;
    height: calc(100% - 58px);
    overflow-y: auto;
  }
  .warnItem {
    width: 100%;
    height: 48px;
    border-bottom: 1px solid rgba(33, 122, 166, 0.2);
    position: relative;
    img {
      width: 24px;
      height: 24px;
      position: absolute;
      top: 12px;
      left: 18px;
    }
    .warningContentShow {
      width: 240px;
      height: 100%;
      display: inline-block;
      position: absolute;
      font-size: 14px;
      color: #ffffff;
      line-height: 48px;
      top: 0;
      left: 48px;
      overflow: hidden;

      text-overflow: ellipsis;
    }
    .warningTimeShow {
      //   width: 240px;
      height: 100%;
      display: inline-block;
      position: absolute;
      font-size: 14px;
      color: #81b6ff;
      line-height: 48px;
      top: 0;
      right: 20px;
    }
  }
  .countItemContent {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 928px;
    height: 480px;
    .leftTravel {
      width: 454px;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-image: url("../images/all/indexType_1.png");
      background-size: 100% 100%;
      padding-top: 60px;
      .typeCheckCon {
        position: absolute;
        width: 150px;
        z-index: 50;
        top: 8px;
        right: 55px;
      }
      .lookBox{
        width: 40px;
        height: 25px;
        line-height: 25px;
        position: absolute;
        top: 17px;
        right: 10px;
        color: #ffffff;
        background: linear-gradient(180deg, rgba(25, 53, 128, 0.9) 0%, rgba(13, 55, 128, 0) 100%);
        text-align: center;
        font-size: 12px;
        border-radius: 4px;
        cursor: pointer;
      }
    }
    .rightTravel {
      width: 454px;
      height: 100%;
      position: absolute;
      top: 0;
      right: 0;
      background-image: url("../images/all/indexType_1.png");
      background-size: 100% 100%;
      padding-top: 60px;
      .typeCheckCon {
        position: absolute;
        width: 150px;
        z-index: 50;
        top: 8px;
        right: 55px;
      }
      .lookBox{
        width: 40px;
        height: 25px;
        line-height: 25px;
        position: absolute;
        top: 17px;
        right: 10px;
        color: #ffffff;
        background: linear-gradient(180deg, rgba(25, 53, 128, 0.9) 0%, rgba(13, 55, 128, 0) 100%);
        text-align: center;
        font-size: 12px;
        border-radius: 4px;
        cursor: pointer;
      }
    }
    .scoreItem {
      width: 100%;
      height: 160px;
      border-top: 1px solid rgba(33, 122, 166, 0.2);
      // cursor: pointer;
    }
    .scoreItem_1 {
      width: 100%;
      height: 160px;
      border-top: 1px solid rgba(33, 122, 166, 0.2);
      border-bottom: 1px solid rgba(33, 122, 166, 0.2);
      // cursor: pointer;
    }
    .itemShow {
      width: 50%;
      height: 100%;
      border-right: 1px solid rgba(33, 122, 166, 0.2);
      float: left;
      position: relative;
    }
    .itemShow_1 {
      width: 50%;
      height: 100%;
      float: left;
      position: relative;
    }
    .scoreNumShow {
      display: inline-block;
      height: 59px;
      line-height: 59px;
      font-size: 48px;
      color: #59c8ff;
      font-weight: bold;
      position: absolute;
      top: 40px;
      left: 50%;
      transform: translateX(-50%);
      font-family: "dinbold";
    }
    .scoreTextShow {
      display: inline-block;
      height: 21px;
      line-height: 21px;
      font-size: 16px;
      color: #fff;
      // font-weight: bold;
      position: absolute;
      top: 100px;
      left: 50%;
      transform: translateX(-50%);
      font-family: MicrosoftYaHei;
    }
    .bottomImg {
      position: absolute;
      width: 100%;
      height: 80px;
      bottom: 0;
      left: 0;
    }
  }
  .adviseContent {
    position: absolute;
    bottom: 0;
    right: 20px;
    width: 454px;
    height: 480px;
    background-image: url("../images/all/indexType_1.png");
    background-size: 100% 100%;
    padding-top: 58px;
  }
  .indexIcon {
    height: 22px;
    width: 19px;
    position: absolute;
    background-image: url("../images/all/indexIcon.png");
    background-size: 100% 100%;
    top: 15px;
    left: 18px;
  }
  .indexTitle {
    position: absolute;
    height: 16px;
    line-height: 16px;
    color: #ffffff;
    font-size: 16px;
    top: 19px;
    left: 45px;
    .effect {
      display: inline-block;
      width: 138px;
      height: 10px;
      background-image: url("../images/all/effect.png");
      background-size: 100% 100%;
      margin-left: 12px;
    }
    
  }
  
}
</style>